import audioCutAPIInstance from "./audioCutApiInstance";

export const abruptCutAPIs = {
  checkAbruptCut: ({ payload }) => audioCutAPIInstance.post(`/abrupt-cut/`, payload),
  bulkCheckAbruptCut: ({ payload }) => audioCutAPIInstance.post(`/abrupt-cut/bulk`, payload),
  saveCut: ({ payload }) => audioCutAPIInstance.post(`/abrupt-cut/save`, payload),
};
